import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { LazyImage } from "react-lazy-images";
// import AvatarLoader from "./AvatarLoader"


export default class HomeImages extends React.Component {
  render() {
    // console.log(this.props.doctor.avatar_url)
    return (
      <LazyImage
        
        src={this.props.image_url}
        alt='Hermina'
        style={{ width: 75 }}
        debounceDurationMs={800}
        actual={({ imageProps }) => <img {...imageProps} />}
        placeholder={({ ref }) => <div ref={ref} />}
        loading={() => (
          <Skeleton circle={true} height={70} width={70} />
          // <AvatarLoader/>
        )}
        error={() => (
          <div className="bg-light-red h-100 w-100">
            <p>There was an error fetching this image :(</p>
          </div>
        )}
      />
      
     
    );
  }
}

